'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messages = require('common/messages');

var _resetPasswordFrompin = require('./reset-password-frompin.html');

var _resetPasswordFrompin2 = _interopRequireDefault(_resetPasswordFrompin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _resetPasswordFrompin2.default,
  bindings: {
    credentials: '<'
  },
  controller: function () {
    function ResetPasswordFromPinComponent($state, ResetPasswordFromPinService, ToastService) {
      'ngInject';

      _classCallCheck(this, ResetPasswordFromPinComponent);

      Object.assign(this, { $state: $state, ResetPasswordFromPinService: ResetPasswordFromPinService, ToastService: ToastService });
    }

    _createClass(ResetPasswordFromPinComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.resetErrorMessages();
      }
    }, {
      key: 'resetErrorMessages',
      value: function resetErrorMessages() {
        this.invalidUsername = false;
        this.invalidNewPassword = false;
        this.invalidPIN = false;
        this.expiredPIN = false;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        var _this = this;

        this.invalidUsername = false;
        this.invalidNewPassword = false;
        this.invalidPIN = false;
        this.expiredPIN = false;
        this.ResetPasswordFromPinService.changePasswordFromPin(_extends({}, this.credentials)).then(function () {
          _this.ToastService.showSuccess(_messages.PASSWORD_RESET);
          _this.$state.go('login');
        }).catch(function (error) {
          if (error && error.data && error.data.Message) {
            if (error.data.Message === 'Invalid New Password') {
              _this.invalidNewPassword = true;
            } else if (error.data.Message === 'Invalid PIN') {
              _this.invalidPIN = true;
            } else if (error.data.Message === 'Expired PIN') {
              _this.expiredPIN = true;
            }
          } else if (error && error.statusText === 'Not Found') {
            _this.invalidUsername = true;
          } else {
            _this.ToastService.showError(error);
          }
        });
      }
    }]);

    return ResetPasswordFromPinComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/auth/reset-password-frompin/reset-password-frompin.component.js